import React, { useState } from 'react';
import style from './Component.module.css'
import useLogout from '../../hooks/useLogout';
import { Link } from 'react-router-dom';

const Component = ({ page, query, links, children }) => {
    const [isOpen, setIsOpen] = useState(false)
    const logOut = useLogout()

    const handleOpen = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            {!!links &&
                <div className="grid lg:grid-cols-12 grid-cols-1 lg:gap-4">
                    <div className='lg:col-span-3 col-span-1'>
                        <div className={style.sidebar}>
                            <div className={style.burger_menu}>
                                <label className={style.burger} onClick={handleOpen}>
                                    <span></span><span></span><span></span>
                                </label>
                            </div>
                            <div className={`${style.sidebar_menu} ${isOpen ? style.slide_open : ''}`} onClick={handleOpen}>
                                <div className={style.sidebar_links} onClick={e => e.stopPropagation()}>
                                    <div className={style.close_side} onClick={handleOpen}>
                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-width="2" d="M3,3 L21,21 M3,21 L21,3"></path></svg>
                                    </div>
                                    <div className={style.loVgtSw_5Q}>
                                        <ul className={style.OcWz_yc1a}>
                                            {links.map(route => {
                                                return (<li className={style.list} key={route.name}>
                                                    <Link to={`/${page}/${route.link ?? ''}`} onClick={handleOpen}
                                                        className={`${style.JbxnrS_6g6d} ${!!(query === route.link) ? style.JbxnrS_active : ''}`}>
                                                        <div className={style.cxZw_p112}>
                                                            <div>
                                                                {route.icon}
                                                            </div>
                                                            <p>{route.name}</p>
                                                        </div>
                                                    </Link>
                                                </li>)
                                            })}
                                            <li className={style.list} onClick={logOut}>
                                                <a className={style.JbxnrS_6g6d}>
                                                    <div className={style.cxZw_p112}>
                                                        <div>
                                                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M312 372c-7.7 0-14 6.3-14 14 0 9.9-8.1 18-18 18H94c-9.9 0-18-8.1-18-18V126c0-9.9 8.1-18 18-18h186c9.9 0 18 8.1 18 18 0 7.7 6.3 14 14 14s14-6.3 14-14c0-25.4-20.6-46-46-46H94c-25.4 0-46 20.6-46 46v260c0 25.4 20.6 46 46 46h186c25.4 0 46-20.6 46-46 0-7.7-6.3-14-14-14z"></path><path d="M372.9 158.1c-2.6-2.6-6.1-4.1-9.9-4.1-3.7 0-7.3 1.4-9.9 4.1-5.5 5.5-5.5 14.3 0 19.8l65.2 64.2H162c-7.7 0-14 6.3-14 14s6.3 14 14 14h256.6L355 334.2c-5.4 5.4-5.4 14.3 0 19.8l.1.1c2.7 2.5 6.2 3.9 9.8 3.9 3.8 0 7.3-1.4 9.9-4.1l82.6-82.4c4.3-4.3 6.5-9.3 6.5-14.7 0-5.3-2.3-10.3-6.5-14.5l-84.5-84.2z"></path></svg>
                                                        </div>
                                                        <p>خروج</p>
                                                    </div>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className={style.sidebar_com}>
                                {children}
                                <div className={style.loVgtSw_5Q}>
                                    <ul className={style.OcWz_yc1a}>
                                        {links.map(route => {
                                            return (
                                                <li className={style.list} key={route.name}>
                                                    <Link to={`/${page}/${route.link ?? ''}`}
                                                        className={`${style.JbxnrS_6g6d} ${!!(query === route.link) ? style.JbxnrS_active : ''}`}>
                                                        <div className={style.cxZw_p112}>
                                                            <div>
                                                                {route.icon}
                                                            </div>
                                                            <p>{route.name}</p>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )
                                        })}
                                        <li className={style.list} onClick={logOut}>
                                            <a className={style.JbxnrS_6g6d}>
                                                <div className={style.cxZw_p112}>
                                                    <div>
                                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M312 372c-7.7 0-14 6.3-14 14 0 9.9-8.1 18-18 18H94c-9.9 0-18-8.1-18-18V126c0-9.9 8.1-18 18-18h186c9.9 0 18 8.1 18 18 0 7.7 6.3 14 14 14s14-6.3 14-14c0-25.4-20.6-46-46-46H94c-25.4 0-46 20.6-46 46v260c0 25.4 20.6 46 46 46h186c25.4 0 46-20.6 46-46 0-7.7-6.3-14-14-14z"></path><path d="M372.9 158.1c-2.6-2.6-6.1-4.1-9.9-4.1-3.7 0-7.3 1.4-9.9 4.1-5.5 5.5-5.5 14.3 0 19.8l65.2 64.2H162c-7.7 0-14 6.3-14 14s6.3 14 14 14h256.6L355 334.2c-5.4 5.4-5.4 14.3 0 19.8l.1.1c2.7 2.5 6.2 3.9 9.8 3.9 3.8 0 7.3-1.4 9.9-4.1l82.6-82.4c4.3-4.3 6.5-9.3 6.5-14.7 0-5.3-2.3-10.3-6.5-14.5l-84.5-84.2z"></path></svg>
                                                    </div>
                                                    <p>خروج</p>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='lg:col-span-9 col-span-1'>
                        {links.find(routes => routes.link === query)?.component}
                    </div>
                </div>
            }
        </>
    );
};

export default Component;